<template>

<!--  <div style="position: absolute; inset: 0px">-->
<!--    <div style="position: relative; max-height: 100%; max-width: 100%; width: 100%; height: 100%">-->
<!--      <div class="fullFilled">-->
<!--        &lt;!&ndash; <StampExchange :page="getStampExchangePageData()" class="fullFilled"/> &ndash;&gt;-->
<!--        <ContentTemplate  class="fullFilled"/>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
    <div style="position: absolute; inset: 0px;">
      <div style="position: relative; max-height: 100%; max-width: 100%; width: 100%; height: 100%">
        <div class="fullFilled">
          <ProjectBudgetInfo class="fullFilled"/>
        </div>
      </div>
    </div>
<!--	<div style="width: 100%;">-->
<!--    <iframe-->
<!--        :src="iframeSrc"-->
<!--        width="100%"-->
<!--        height="100%"-->
<!--        frameborder="0"-->
<!--        scrolling="no">-->
<!--    </iframe>-->
<!--  </div>-->
<!--		<div id="content" style="margin: 0;padding: 0;" ref="print-content">-->
<!--		    <div class="pageItem">-->
<!--		      <div v-for="(itemIn,index) in dataList" :key="index" style="width: 50%;float: left;" >-->
<!--		        <div style="text-align: center;font-weight:  bold;font-size: 17px;line-height: 40px;margin: 5px 3px 2px 3px;">-->
<!--		          团购券 99 （TG）</div>-->
<!--		        <div style="width: 60%;padding-left: 4%;float: left;">-->
<!--		          <img :id="'barcode-' + itemIn.id" style="width: 100%;height: 60px;">-->
<!--		          <div style="text-align: center;margin-top: -5px;font-size: 15px;">310520896006060</div>-->
<!--		        </div>-->
<!--		        <div style="width: 31%;float: left;text-align: center;padding-left: 5%;">-->
<!--		          <div style="text-align: center;font-size: 26px;font-weight: bold;line-height: 60px;float: left;">100.9</div>-->
<!--		          <div style="text-align: left;font-size: 25px;font-weight: bold;line-height: 90px;float: left;">元</div>-->
<!--		        </div>-->
<!--		        <div style="width: 5%;float: right;font-weight: 400;font-size: 14px;">-->
<!--		          赠-->
<!--		        </div>-->
<!--		        <div style="clear: both;margin-top: 5px;"></div>-->
<!--		        <div style="padding-left: 4%;width: 96%;">-->
<!--		          <div style="font-size: 12px;line-height: 20px;">-->
<!--		            <span style="float: left;">♦限&nbsp;&nbsp;镇江区域通用&nbsp;&nbsp;使用;</span>-->
<!--		            <span style="float: right;">♦此券不兑现，不找零，遗失不补</span>-->
<!--		          </div>-->
<!--		          <div style="clear: both;"></div>-->
<!--		          <div style="font-size: 12px;line-height: 20px;">-->
<!--		            ♦名烟名酒类不参与本次活动；-->
<!--		          </div>-->
<!--		          <div style="font-size: 12px;line-height: 20px;">-->
<!--		            <div style="width: 18%;float: left;text-align: left;font-size: 12px;">♦此券仅限</div>-->
<!--		            <div style="width: 35%;float: left;text-align: center;font-size: 12px;">2022.9.8-2023.9.8</div>-->
<!--		            <div style="width: 47%;float: left;text-align: right;font-size: 12px;">使用，过期作废，盖章有效</div>-->
<!--		          </div>-->
<!--		          <div style="clear: both;margin-top: 5px;"></div>-->
<!--		        </div>-->
<!--		-->
<!--		      </div>-->
<!--		    </div>-->
<!--			<div class="pageItem">-->
<!--				<div v-for="(itemIn,index) in dataList" :key="index" style="width: 50%;float: left;" >-->
<!--				  <div style="text-align: center;font-weight:  bold;font-size: 17px;line-height: 40px;margin: 5px 3px 2px 3px;">-->
<!--				    团购券 99 （TG）</div>-->
<!--				  <div style="width: 60%;padding-left: 4%;float: left;">-->
<!--				    <img :id="'barcode-' + itemIn.id" style="width: 100%;height: 60px;">-->
<!--				    <div style="text-align: center;margin-top: -5px;font-size: 15px;">310520896006060</div>-->
<!--				  </div>-->
<!--				  <div style="width: 31%;float: left;text-align: center;padding-left: 5%;">-->
<!--				    <div style="text-align: center;font-size: 26px;font-weight: bold;line-height: 60px;float: left;">100.9</div>-->
<!--				    <div style="text-align: left;font-size: 25px;font-weight: bold;line-height: 90px;float: left;">元</div>-->
<!--				  </div>-->
<!--				  <div style="width: 5%;float: right;font-weight: 400;font-size: 14px;">-->
<!--				    赠-->
<!--				  </div>-->
<!--				  <div style="clear: both;margin-top: 5px;"></div>-->
<!--				  <div style="padding-left: 4%;width: 96%;">-->
<!--				    <div style="font-size: 12px;line-height: 20px;">-->
<!--				      <span style="float: left;">♦限&nbsp;&nbsp;镇江区域通用&nbsp;&nbsp;使用;</span>-->
<!--				      <span style="float: right;">♦此券不兑现，不找零，遗失不补</span>-->
<!--				    </div>-->
<!--				    <div style="clear: both;"></div>-->
<!--				    <div style="font-size: 12px;line-height: 20px;">-->
<!--				      ♦名烟名酒类不参与本次活动；-->
<!--				    </div>-->
<!--				    <div style="font-size: 12px;line-height: 20px;">-->
<!--				      <div style="width: 18%;float: left;text-align: left;font-size: 12px;">♦此券仅限</div>-->
<!--				      <div style="width: 35%;float: left;text-align: center;font-size: 12px;">2022.9.8-2023.9.8</div>-->
<!--				      <div style="width: 47%;float: left;text-align: right;font-size: 12px;">使用，过期作废，盖章有效</div>-->
<!--				    </div>-->
<!--				    <div style="clear: both;margin-top: 5px;"></div>-->
<!--				  </div>-->
<!--				</div>		-->
<!--			</div>-->
<!--		</div>-->
<!--	</div>-->
<!--  <div style="position: absolute; inset: 0px;">-->
<!--    <div style="position: relative; max-height: 100%; max-width: 100%; width: 100%; height: 100%">-->
<!--      <div class="fullFilled" style="overflow: auto">-->
<!--        <div class="btn" @click="print" v-show="!isPrint">打印</div>-->
<!--        &lt;!&ndash; <StampExchange :page="getStampExchangePageData()" class="fullFilled"/> &ndash;&gt;-->
<!--&lt;!&ndash;        <ProjectBudgetInfo class="fullFilled"/>&ndash;&gt;-->
<!--        <div id="content" style="padding: 0px 5%;"  ref="print-content">-->
<!--          <div v-for="(item,index) in dataList" :key="index" style="width: 50%;float:left;" >-->
<!--            &lt;!&ndash; 文章详情 &ndash;&gt;-->
<!--            <div v-show="!isPrint">不需要打印的内容</div>-->
<!--            <div style="text-align: center;font-weight:  bold;font-size: 17px;line-height: 40px;margin-bottom: 5px;">提货券 49 (JH)</div>-->
<!--            <div style="width: 60%;float: left;">-->
<!--              <img id="barcode1" style="width: 100%;height: 60px;">-->
<!--              <div style="text-align: center;margin-top: -5px;font-size: 15px;">310100515268363131</div>-->
<!--            </div>-->
<!--            <div style="width: 35%;float: left;text-align: center;padding-left: 5%;">-->
<!--              <div style="text-align: center;font-size: 26px;font-weight: bold;line-height: 60px;float: left;">120.9</div>-->
<!--              <div style="text-align: left;font-size: 25px;font-weight: bold;line-height: 90px;float: left;">元</div>-->
<!--            </div>-->
<!--            <div style="width: 5%;float: right;font-weight: 400;font-size: 14px;">-->
<!--              赠-->
<!--            </div>-->
<!--            <div style="clear: both;margin-top: 5px;"></div>-->
<!--            <div style="font-size: 12px;line-height: 20px;">-->
<!--              ♦限&nbsp;&nbsp;镇江区域通用&nbsp;&nbsp;使用;-->
<!--            </div>-->
<!--            <div style="font-size: 12px;line-height: 20px;">-->
<!--              ♦名烟名酒类、大家电类、黄金珠宝类不参与本次活动；-->
<!--            </div>-->
<!--            <div style="font-size: 12px;line-height: 20px;">-->
<!--              <div style="width: 18%;float: left;text-align: left;font-size: 12px;">♦此券仅限</div>-->
<!--              <div style="width: 35%;float: left;text-align: center;font-size: 12px;">2022.9.8-2023.9.8</div>-->
<!--              <div style="width: 47%;float: left;text-align: right;font-size: 12px;">使用，过期作废，盖章有效</div>-->
<!--            </div>-->
<!--            <div style="clear: both;margin-top: 5px;"></div>-->
<!--          </div>-->
<!--          <div style="width: 50%;float:left;">-->
<!--            &lt;!&ndash; 文章详情 &ndash;&gt;-->
<!--            <div v-show="!isPrint">不需要打印的内容</div>-->
<!--            <div style="text-align: center;font-weight:  bold;font-size: 17px;line-height: 40px;margin-bottom: 20px;">提货券 49 (JH)</div>-->
<!--            <div style="width: 60%;float: left;">-->
<!--              <img id="barcode1" style="width: 100%;height: 60px;">-->
<!--              <div style="text-align: center;margin-top: -5px;font-size: 15px;">310100515268363131</div>-->
<!--            </div>-->
<!--            <div style="width: 35%;float: left;text-align: center;padding-left: 5%;">-->
<!--              <div style="text-align: center;font-size: 26px;font-weight: bold;line-height: 60px;float: left;">102.9</div>-->
<!--              <div style="text-align: left;font-size: 25px;font-weight: bold;line-height: 90px;float: left;">元</div>-->
<!--            </div>-->
<!--            <div style="width: 5%;float: right;font-weight: 400;font-size: 14px;">-->
<!--              赠-->
<!--            </div>-->
<!--            <div style="clear: both;margin-top: 20px;"></div>-->
<!--            <div style="font-size: 12px;line-height: 25px;">-->
<!--              ♦限&nbsp;&nbsp;镇江区域通用&nbsp;&nbsp;使用;-->
<!--            </div>-->
<!--            <div style="font-size: 12px;line-height: 25px;">-->
<!--              ♦名烟名酒类、大家电类、黄金珠宝类不参与本次活动；-->
<!--            </div>-->
<!--            <div style="font-size: 12px;line-height: 25px;">-->
<!--              <div style="width: 18%;float: left;text-align: left;font-size: 12px;">♦此券仅限</div>-->
<!--              <div style="width: 35%;float: left;text-align: center;font-size: 12px;">2022.9.8-2023.9.8</div>-->
<!--              <div style="width: 47%;float: left;text-align: right;font-size: 12px;">使用，过期作废，盖章有效</div>-->
<!--            </div>-->
<!--            <div style="clear: both;margin-top: 20px;"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

</template>

<script>
//import StampExchange from "../sm/market/coupon-activity/stamp-exchange/StampExchange";
// import ContentTemplate from "../sm/market/printcoupon/contenttemplate/ContentTemplate"
//import OrgManage from "../smp/org/org/OrgManage";
// import ContentTemplate from "../alarm/workbench/taskDetail";
import ContentTemplate from "../alarm/template/createTemplate"
import ProjectBudgetInfo from "../pd/budget/project/budgetInfo";
import JsBarCode from 'jsbarcode'
export default {
  name: "TestBill",
  props: ["page"],
  components: {
    ProjectBudgetInfo: ProjectBudgetInfo
  },
  data() {
    return {
      isPrint: false,
      info: {
        marIdCode: '123456',
        imgHeight: '10px'
      },
      dataList: [
        {id: 1},
        {id: 2},
        {id: 3},
        {id: 4},
        {id: 5},
        {id: 6},
        {id: 7},
        {id: 8},
        {id: 9},
        {id: 10},
        {id: 11},
        {id: 12}
      ],
      showMemberInfo: false,
      iframeSrc: ''
    };
  },
  methods: {
    // 打印
    print() {
      this.isPrint = true;
      setTimeout(() => {
        this.$print(this.$refs['print-content'])  //打印
        this.isPrint = false;
      });
    },
    getStampExchangePageData() {
      return {'id':'512'};
    },
    getContentTemplatePageData() {
      return {'id':'906'};
    },
    getDepartmentManageData() {
      return {'id':'61'};
    },
    getOrgManageData() {
      return {'id':'931'};
    },
  },

  mounted() {
    this.iframeSrc = `/printItem?id=1600372031461281794`
    this.showMemberInfo = true
    console.log("test page mounted");
    console.log(this.page);
	// this.dataList.map(item => {
	// 	JsBarCode('#barcode' + item.id, 'DY2020080400088', {
	// 	  format: 'CODE39',
	// 	  lineColor: '#000',
	// 	  background: '#fff',
	// 	  width: 3,
	// 	  height: 80,
	// 	  displayValue: false
	// 	})
	// })
    
  },
};
</script>

<style scoped>

    .fullFilled{
        padding:0px;
		    margin: 0px;
		    width:100%;
		    height:100%;
    }

</style>